
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import Card from '@devsisters/ui-careers/lib/Card';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"card"}}>{`Card`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { Card } from '@devsisters/ui/careers';
// 또는 import Card from '@devsisters/ui-careers/lib/Card';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<Card shadow=\"small\">\n  <h1>작은 그림자</h1>\n</Card>\n<Card shadow=\"big\">\n  <h1>커다란 그림자</h1>\n</Card>'} __scope={{props: this ? this.props : props,Card}}>
  <Card shadow='small'>
    <h1>작은 그림자</h1>
  </Card>
  <Card shadow='big'>
    <h1>커다란 그림자</h1>
  </Card>
</Playground>
           </MDXTag>
  }
}
  